import { ConnectivityTestResults } from './ConnectivityTestResults/ConnectivityTestResults';
import React from 'react';
import { TestResults } from '../types';
import { DNSLookupTestResults } from './DNSLookupTestResults/DNSLookupTestResults';
import { Fade } from '@material-ui/core';

export default function ResultWidget({ results }: { results?: TestResults }) {
  return (
    <>
      {results && (
        <Fade in={true} timeout={2000}>
          <>
            <ConnectivityTestResults results={results} />
            <DNSLookupTestResults results={results} />
          </>
        </Fade>
      )}
    </>
  );
}
